import { useState } from "react";
import { toast } from "sonner";
import { Megaphone, Pin, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { EmptyState, SectionTitle, Spinner } from "@/components/common";
import { useLoad, useTrip } from "@/context/TripContext";
import { api, errMsg, fmtDate } from "@/lib/api";

export default function News() {
  const { tid, isOrg } = useTrip();
  const [list, reload] = useLoad(`/trips/${tid}/announcements`);
  const [f, setF] = useState({ title: "", body: "", pinned: false, send_email: false });
  if (!list) return <Spinner />;
  const post = async (e) => {
    e.preventDefault();
    try { const { data } = await api.post(`/trips/${tid}/announcements`, f); toast.success(f.send_email ? `Posted and emailed to ${data.emailed} traveler(s)` : "Posted"); setF({ title: "", body: "", pinned: false, send_email: false }); reload(); } catch (er) { toast.error(errMsg(er)); }
  };
  const del = async (a) => { try { await api.delete(`/trips/${tid}/announcements/${a.announcement_id}`); reload(); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <div className="grid gap-6 lg:grid-cols-[3fr_2fr]">
      <div className="space-y-3">
        <SectionTitle title="Announcements" />
        {list.length === 0 ? <EmptyState icon={Megaphone} title="No announcements yet" text="Important updates from organizers show up here and in everyone's notifications." /> :
          list.map((a) => (
            <div key={a.announcement_id} className={`card p-5 ${a.pinned ? "border-l-4 border-l-orange-500" : ""}`} data-testid={`announcement-${a.announcement_id}`}>
              <div className="flex items-start justify-between gap-2"><h3 className="font-bold">{a.pinned && <Pin className="mr-1 inline h-4 w-4 text-orange-500" />}{a.title}</h3>
                {isOrg && <Button size="icon" variant="ghost" onClick={() => del(a)} aria-label="Delete" data-testid={`delete-announcement-${a.announcement_id}`}><Trash2 className="h-4 w-4 text-rose-500" /></Button>}</div>
              <p className="mt-2 whitespace-pre-line text-sm text-slate-700">{a.body}</p>
              <p className="mt-2 text-xs text-slate-500">{a.author_name} · {fmtDate(a.created_at)}</p>
            </div>))}
      </div>
      {isOrg && (
        <form onSubmit={post} className="card h-fit space-y-3 p-5" data-testid="announcement-form">
          <h3 className="font-bold">Post an update</h3>
          <Input required placeholder="Title" value={f.title} onChange={(e) => setF({ ...f, title: e.target.value })} data-testid="announcement-title-input" />
          <Textarea required rows={5} placeholder="What does everyone need to know?" value={f.body} onChange={(e) => setF({ ...f, body: e.target.value })} data-testid="announcement-body-input" />
          <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={f.pinned} onChange={(e) => setF({ ...f, pinned: e.target.checked })} data-testid="announcement-pin-checkbox" />Pin to top</label>
          <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={f.send_email} onChange={(e) => setF({ ...f, send_email: e.target.checked })} data-testid="announcement-email-checkbox" />Also email travelers (respects their email settings)</label>
          <Button type="submit" className="w-full rounded-full" data-testid="announcement-submit">Post</Button>
        </form>
      )}
    </div>
  );
}
